import { ArnComponent } from '../ArnComponent';

export class ArnIfComponent extends ArnComponent {
  static readonly ATTR_CONDITION = 'condition';
  static readonly ATTRS = [ArnIfComponent.ATTR_CONDITION];

  /**
   * Displayed when the condition is true.
   */
  protected trueElem!: HTMLElement;
  protected falseElem!: HTMLElement;

  /**
   * (Even if not recommended) a subclass constructor could change this slot name
   * to provide semantics better suited to its specialization.
   */
  protected _falseSlotName = 'if-false';

  /**
   * (Even if not recommended) a subclass constructor could change this slot name
   * to provide semantics better suited to its specialization.
   */
  protected _trueSlotName = 'if-true';

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: 'open' });
    const falseElem = (this.falseElem = this.createSlot(this._falseSlotName));
    shadowRoot.appendChild(falseElem);
    const trueElem = (this.trueElem = this.createSlot(this._trueSlotName));
    shadowRoot.appendChild(trueElem);
    this.setInitial(ArnIfComponent.observedAttributes);
  }

  protected setInitial(attrs: string[]) {
    for (const attr of attrs) {
      this.attributeChangedCallback(attr, null, this.getAttribute(attr));
    }
  }

  get falseSlotName(): string {
    return this._falseSlotName;
  }

  get trueSlotName(): string {
    return this._trueSlotName;
  }

  static get observedAttributes(): string[] {
    return ArnIfComponent.ATTRS;
  }

  protected updateUI(isTrue: boolean) {
    this.log.debug('updateUI', isTrue);
    this.falseElem.style.display = isTrue ? 'none' : '';
    this.trueElem.style.display = isTrue ? '' : 'none';
  }

  attributeChangedCallback(
    name: string,
    _oldValue: string | null,
    newValue: string | null
  ) {
    if (name === ArnIfComponent.ATTR_CONDITION) {
      this.setConditionAttr(newValue);
    }
  }

  protected setConditionAttr(newValue: string | null) {
    const isTrue = newValue ? eval(newValue) : false;
    this.updateUI(isTrue);
  }
}

const name = 'arn-if';
if (!window.customElements.get(name)) {
  window.customElements.define(name, ArnIfComponent);
}
